<template>
  <SideBar :width="getSideBarWidth()">
    <template #side-bar-activator>
      <Activator
        class="self-centered cursor-e-resize"
        :key="`side_bar_activator>`"
        @mousedown.native="$router.push({
          name: 'ProjectTaktPlan',
          })"
        />
    </template>
    <template #content>
      <WaggonInfo>
        <template #header>
          <draggable
            class="display-flex"
            style="width: calc(100% - 32px)"
            :key="`workpackages${twaggon_id}`"
            animation="300"
            forceFallback="true"
            fallbackOnBody="true"
            :value="waggon.tworkpackages"
            @end="($event.newIndex - $event.oldIndex !== 0)?requestSnackbarUpdatePosition({
              url: [
                {projects: project_id},
                {trains: train_id},
                {taktareas: taktarea_id},
                {twaggons: twaggon_id},
                {tworkpackages: waggon.tworkpackages[$event.oldIndex]}
              ],
              update: {
                position: $event.newIndex - $event.oldIndex
              }
            }).then((payload) => {
              updateUObjectPosition(payload)
            }):''"
          >
          <!-- @end="tWorkPackageChangePosition({
            project_id: project_id,
            train_id: train_id,
            taktarea_id: taktarea_id,
            twaggon_id: twaggon_id,
            drag_evt: {
              oldIndex: $event.oldIndex,
              newIndex: $event.newIndex
            },
            snack_bar: { bulk: false }
          })" -->
          <WaggonInfoHeader
            v-for="(workpackage, index) in getUObjects({type: 'tworkpackages', ids: waggon.tworkpackages})"
            :key="'header' + workpackage.id"
            :width="getHeaderWidth(workpackage.id)"
            :textcolor="workpackage.textcolor"
            :color="workpackage.color"
            :text="workpackage.token"
            :wp_part="workpackage.workpackage_part"
            :icon="workpackage.icon"
            cursor="grab"
            @click.native="$router.push({
              name: !$route.name.includes('TaktPlanAddWorkPackage')?$route.name:'TaktPlanWorkPackageInfo',
              params: {
                tworkpackage_id: workpackage.id,
                }
              })"
          >
          <!-- isEditMode?'TaktPlanWorkPackageEdit':'TaktPlanWorkPackageInfo' -->
          <v-btn
            icon
            small
            :color="workpackage.textcolor"
            @click.prevent.stop="
            getNestedWorkPackageCopy(workpackage.id).then(work_package => {
                updateWBLObject({
                path: [
                {workpackage: ''}
                ],
                update: work_package
                }),
                $router.push({
                  name: 'TaktPlanWorkPackageCopy',
                  params: {
                    editor_work_package_id: 'create',
                  }
                })
              })
            "
            >
            <v-icon small>content_copy</v-icon>
          </v-btn>
          <StandardDeleteButton
            :zoom="1"
            @clickDelete="requestSnackbarDelete({
                url: [
                  {projects: project_id},
                  {trains: train_id},
                  {taktareas: taktarea_id},
                  {twaggons: twaggon_id},
                  {tworkpackages: workpackage.id}
                ],
              }).then((payload) => {
                waggon.tworkpackages.length > 1?
                $router.push({
                  name: 'TaktPlanWorkPackageEdit',
                  params: {
                    tworkpackage_id: index === waggon.tworkpackages.length-1?waggon.tworkpackages[index-1]:waggon.tworkpackages[index+1],
                  }
                  })
                  :
                  $router.push({
                    name: 'TaktPlanAddWorkPackage',
                  }),
                deleteUObject(payload)
              })"
            />
            <!-- @clickDelete="tWorkPackageDelete({
              project_id: project_id,
              train_id: train_id,
              taktarea_id: taktarea_id,
              twaggon_id: twaggon_id,
              twork_package_id: workpackage.id,
              twork_package_index: work_package_index,
              snack_bar: { bulk: false }
            })" -->
        </WaggonInfoHeader>
        </draggable>
          <WaggonInfoHeaderAdd
            @click.native="$router.push({
              name: 'TaktPlanAddWorkPackage'
              })"
          />
        </template>
        <template #body>
          <router-view></router-view>
        </template>
      </WaggonInfo>
    </template>
  </SideBar>
</template>

<script>
import draggable from "vuedraggable";

import SideBar from '@/components/ProjectTaktPlan/SideBar.component.vue'
import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'

import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js'
import { SideBarMixin } from '@/mixins/SideBar.mixin.js'
export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_id', 'tworkpackage_id', 'waggon'],
  components: {
    SideBar,
    Activator,
    draggable,
  },
  mixins: [
    WaggonInfoMixin,
    SideBarMixin
  ],
  data: () => ({
  }),
  computed: {
  },
  methods: {
  },
  // created() {
  //   if (!this.tworkpackage_id) {
  //     this.$router.push({
  //       name: this.isEditMode?'TaktPlanWorkPackageEdit':'TaktPlanWorkPackageInfo',
  //       params: {
  //         tworkpackage_id: this.getTWaggon(this.twaggon_id).twork_packages[0],
  //         }
  //       })
  //   }
  // }
}
</script>
<style>
</style>
